module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shouldReceiveAutomatedMails":"Receives automatically sent emails","shouldReceiveManualMails":"Receives manually sent emails","shouldReceiveAutomatedChemicalMails":"Receives chemical update emails","postLoginDestination":"Post login destination","UserAccess":"Insufficient permissions to edit user","accessTemplate":"Access template"}}')
  delete Component.options._Ctor
}
